// 現在開いているページのURLを取得
function getCurrentPageUrl(){
    // urlを取得
    var locationUrl = location.href;

    // check current Lang
    var langList = {
        'ko':'https://shop.da-ice.jp/ko',
        'zh':'https://shop.da-ice.jp/zh-hans',
        'tw':'https://shop.da-ice.jp/zh-hant',
        'en':'https://shop.da-ice.jp/en',
        'ja':'https://shop.da-ice.jp'
    };

    // page URL
    var locationPageUrl = '';

    if( locationUrl.indexOf( langList['ko'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['ko'] )[1].split("?")[0];

    } else if( locationUrl.indexOf( langList['zh'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['zh'] )[1].split("?")[0];

    } else if( locationUrl.indexOf( langList['tw'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['tw'] )[1].split("?")[0];

    } else if( locationUrl.indexOf( langList['en'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['en'] )[1].split("?")[0];

    } else if( locationUrl.indexOf( langList['ja'] ) != -1 ){
      locationPageUrl = locationUrl.split( langList['ja'] )[1].split("?")[0];

    }

    // page URL綺麗にするために配列化
    var locationPageUrlList = locationPageUrl.split('/');

    // 頭の/を除いたパスを格納する配列
    var pageUrlList = [];
  
    for(var i = 0; i < locationPageUrlList.length; i++){
      // 値が空でなければ、パスを追加
      if( locationPageUrlList[i] !== '') {
        pageUrlList.push(locationPageUrlList[i] );
      }
    }

    // 商品説明を取得
    var pageUrl = pageUrlList.join('/');

    return pageUrl;
}

// 指定された言語にリダイレクト
function redirectLangPage( setLang ) {
    // sサイト URL
    var siteUrl = '';

    // リダイレクトするURLとクエリパラメータを取得
    if(setLang == "usd") {
        siteUrl = 'https://shop.da-ice.jp/en';

    } else if(setLang == "krw") {
        siteUrl = 'https://shop.da-ice.jp/ko';

    } else if(setLang == "cny") {
        siteUrl = 'https://shop.da-ice.jp/zh-hans';

    } else if(setLang == "twd") {
        siteUrl = 'https://shop.da-ice.jp/zh-hant';

    } else if(setLang == "jpy") {
        siteUrl = 'https://shop.da-ice.jp';

    }

    // 現在開いているページのURLを取得
    var pageUrl = getCurrentPageUrl();

    if( pageUrl !== '' ){
      // リダイレクト先のURL
      var redirectUrl = siteUrl + '/' + pageUrl;

    } else {
      // リダイレクト先のURL
      var redirectUrl = siteUrl;

    }

    //console.log(redirectUrl);

    window.location.href = redirectUrl;

}
